let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jUeQe")).then(() => parcelRequire('8OTRA'));